import React from 'react';


const HeaderTopS2 = () => {
    return (
        <div className="topbar s2">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-12">
                        <div className="contyact-info-wrap">
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-phone-call"></i>
                                </div>
                                <div className="info-text">
                                    <span>Call Us:</span>
                                    <p>00 567 458 796 47</p>
                                </div>
                            </div>
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-email"></i>
                                </div>
                                <div className="info-text">
                                    <span>E-mail Now:</span>
                                    <p>infoorgco@gmail.com</p>
                                </div>
                            </div>
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-clock"></i>
                                </div>
                                <div className="info-text">
                                    <span>Opening Hours:</span>
                                    <p>09:00 am to 10:00 pm</p>
                                </div>
                            </div>
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-location-1"></i>
                                </div>
                                <div className="info-text">
                                    <span>Our Location:</span>
                                    <p>8932, Natiska, USA.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderTopS2;